export const ADD_USER = "ADD_USER";
export const REMOVE_USER = "REMOVE_USER";
export const UPDATE_USER = "UPDATE_USER";

export const SET_HIDDEN = "SET_HIDDEN";
export const SET_USERS = "SET_USERS";
